import { Link } from "react-router-dom";
import closeModal from "../../assets/images/closeModal.png";

import downloadImgModal from "../../assets/images/downloadImgModal.webp";
import googleplay from "../../assets/images/playstore.svg";
import appstore from "../../assets/images/appstore.svg";
import QrCode from "../../assets/images/downloadModal/QrCode.png";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import x from "../../assets/images/downlaodcross.svg";
import { Helmet } from "react-helmet";

function DownloadModal({ show, setShow, id }) {
  const { i18n, t } = useTranslation();
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
      textAlign: "right",
    };
  } else {
    var arabStyle = {};
  }
  // Close modal when ESC key is pressed
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setShow(false);
      }
    };
    if (show) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [show]);

  if (!show) return null;
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Become a seller and get paid. Sell pre-loved luxury fashion, from pre-loved designer bags, shoes and accessories of Gucci, Louis Vuitton, Prada and more."
        />
        <title>Sell Luxury Fashion Dubai - Libas</title>
      </Helmet>
      {/* for desktop/Ipads/Tablets */}
      <div
        className=""
        onClick={() => setShow(false)}
        style={{
          zIndex: 9999,
        }}
      >
        <div
          className="d-none d-md-flex p-0 m-0 mt-0 pt-0 d-flex align-items-center montserrat-font downlaodmodal-desktops"
          style={{
            backgroundColor: "white",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            height: "100vh",
          }}
        >
          <div
            className="row shadow-lg downlaod-modal-popup"
            style={{
              margin: "0 auto",
            }}
          >
            {/* left */}
            <div
              className="col-6"
              style={{
                backgroundColor: "white",
              }}
            >
              <div
                className="flex-col"
                style={{
                  paddingLeft: "30px",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#000000",
                    marginTop: "64px",
                  }}
                >
                  <p>
                    {" "}
                    {i18n.language == "ar"
                      ? "قم بفتح هذه الميزة على تطبيقنا للجوال!"
                      : "Unlock this feature on our mobile app!"}
                  </p>
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    color: "#000000",
                  }}
                >
                  <p>
                    {i18n.language == "ar"
                      ? "لأفضل تجربة، قم بتنزيل تطبيقنا للجوال الآن واستمتع بوصول سلس إلى هذه الميزة."
                      : "For the best experience, download our\nmobile app now and enjoy seamless\naccess to this functionality."}
                  </p>
                </div>

                {/* icons & QR */}
                <div
                  className="d-flex  align-items-center"
                  style={{
                    paddingTop: "60px",
                  }}
                >
                  {/* left */}
                  <div className="flex-col m-0 p-0 ">
                    {/* google play */}
                    <div>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.libas.libas&pli=1"
                        aria-label="Download Libas UAE App on Google Play Store"
                      >
                        <img src={googleplay} className="" alt="main" />
                      </a>
                    </div>
                    {/* playstore */}
                    <div className="mt-1">
                      <a
                        href="https://apps.apple.com/app/libas-uae/id1605637445"
                        aria-label="Download Libas App on the Apple App Store"
                      >
                        <img src={appstore} className="" alt="main" />
                      </a>
                    </div>
                  </div>
                  {/* right scanner*/}
                  <div className="mt-0">
                    <div className="">
                      <img
                        src={QrCode}
                        alt="main"
                        className=""
                        style={{
                          height: "78px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* right img*/}
            <div
              className="col-6 m-0 p-0 "
              style={{
                backgroundColor: "#FBF5F0",
                position: "relative",
              }}
            >
              <div
                className=" "
                aria-label="Close"
                onClick={() => setShow(false)}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "12px",
                  cursor: "pointer",
                }}
              >
                <img
                  src={x}
                  onClick={() => setShow(false)}
                  className="cursor-pointer"
                  alt="main"
                />
              </div>
              <img
                src={downloadImgModal}
                alt="main"
                style={{
                  width: "100%",
                  height: "398px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* for mobile */}
      <div
        className="d-flex d-md-none downlaodmodal-mobile  modal-backdrop d-flex align-items-center justify-content-center p-0 m-0 montserrat-font"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1050,
          overflow: "hidden",
        }}
      >
        <div
          className="modal-content  p-0"
          style={{
            maxWidth: "90%",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <div className="row no-gutters shadow-lg">
            {/* Mobile-First Layout: Stack columns on small screens */}
            <div
              className="col-12 col-md-6 order-2 order-md-1 bg-white"
              style={{
                padding: "10px",
              }}
            >
              <div className="text-center text-md-left">
                <div
                  className="mb-1"
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#000000",
                  }}
                >
                  <p className="mb-0">
                    {i18n.language == "ar"
                      ? "قم بفتح هذه الميزة على تطبيقنا للجوال!"
                      : "Unlock this feature on our mobile app!"}
                  </p>
                </div>
                <div
                  className="mb-1"
                  style={{
                    fontSize: "10px",
                    fontWeight: "400",
                    color: "#000000",
                  }}
                >
                  <p className="mb-0">
                    {i18n.language == "ar"
                      ? "لأفضل تجربة، قم بتنزيل تطبيقنا للجوال الآن واستمتع بوصول سلس إلى هذه الميزة."
                      : "For the best experience, download our\nmobile app now and enjoy seamless\naccess to this functionality."}
                  </p>
                </div>

                {/* App Store Links & QR Code */}
                <div className="d-flex align-items-center justify-content-center">
                  <div className="d-flex flex-column  ">
                    {/* Google Play */}
                    <a
                      href="https://play.google.com/store/apps/details?id=com.libas.libas&pli=1"
                      aria-label="Download Libas UAE App on Google Play Store"
                      className="mb-2"
                    >
                      <img
                        src={googleplay}
                        alt="Google Play"
                        className="img-fluid"
                        style={{ maxWidth: "150px" }}
                      />
                    </a>

                    {/* App Store */}
                    <a
                      href="https://apps.apple.com/app/libas-uae/id1605637445"
                      aria-label="Download Libas App on the Apple App Store"
                    >
                      <img
                        src={appstore}
                        alt="App Store"
                        className="img-fluid"
                        style={{ maxWidth: "150px" }}
                      />
                    </a>
                  </div>

                  {/* QR Code */}
                  <div className="mt-0">
                    <img
                      src={QrCode}
                      alt="QR Code"
                      className="img-fluid"
                      style={{
                        maxHeight: "80px",
                        maxWidth: "100px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Right Image Section */}
            <div
              className="col-12 col-md-6 order-1 order-md-2 position-relative"
              style={{
                backgroundColor: "#FBF5F0",
              }}
            >
              {/* Close Button */}
              <div
                className="position-absolute"
                style={{
                  top: "12px",
                  right: "22px",
                  cursor: "pointer",
                  zIndex: 10,
                }}
              >
                <img
                  src={x}
                  alt="Close"
                  onClick={() => setShow(false)}
                  className="cursor-pointer"
                  style={{ width: "16px", height: "16px" }}
                />
              </div>

              <img
                src={downloadImgModal}
                alt="Download Modal"
                className="img-fluid w-100"
                style={{
                  objectFit: "contain",
                  maxHeight: "398px",
                  height: "200px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DownloadModal;
